import script from "./PaymentConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./PaymentConfirmation.vue?vue&type=style&index=0&id=098efd9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-098efd9c"]])

export default __exports__